import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  class: "fm-table__column--score__current",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "fm-table__column--score__change__number" }

import { computed } from 'vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { type IconDefinition } from 'fontawesome/pro-regular-svg-icons'
import DataTable from 'primevue/datatable'
import {
    getAriaScoreDesc,
    getDiffIcon,
    getDiffVariant,
} from '@/utils/frontlineManagerDash'
import { formatScoreWithPercentage } from '@/utils/number'
import { tabletBreakpoint } from '@/utils/breakpoints'
import { ILeaderboardResult } from '@/entities/leaderboard'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import LeaderboardTableColumn from '@/components/FrontlineManagerDash/LeaderboardTableColumn.vue'

interface Props {
    title: string
    dataLabel: string
    loading: boolean
    icon: IconDefinition
    leaderboard: ILeaderboardResult[]
    metric: string
    timePeriod: string
    csatAsPercent: boolean
    isFiveScore: boolean
    decimals: {
        nps: number
        csat: number
        fivestar: number
        ces: number
    }
    showError?: boolean
    onReloadClick?: Function
    rowsToShow?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LeaderboardTable',
  props: {
    title: {},
    dataLabel: {},
    loading: { type: Boolean },
    icon: {},
    leaderboard: {},
    metric: {},
    timePeriod: {},
    csatAsPercent: { type: Boolean },
    isFiveScore: { type: Boolean },
    decimals: {},
    showError: { type: Boolean, default: false },
    onReloadClick: { type: Function, default: () => ({}) },
    rowsToShow: { default: 8 }
  },
  setup(__props: any) {

const props = __props

const loadingRows = Array.from({ length: props.rowsToShow }, () => ({}))

const rankedLeaderboard = computed(() => {
    return (
        props.leaderboard?.map((item, index) => ({
            ...item,
            rank: index + 1,
        })) ?? []
    )
})

const dataTablePt = {
    bodyRow: { style: { background: 'unset' } },
    thead: { style: { zIndex: 0 } },
}

const tableScrollHeight = computed(() => {
    const headerHeight = 41
    const rowHeight = 57
    return `${props.rowsToShow * rowHeight + headerHeight}px`
})

const showResponsesColumn = computed(
    () => window.innerWidth >= tabletBreakpoint
)

return (_ctx: any,_cache: any) => {
  return (_ctx.loading || _ctx.showError || _ctx.leaderboard?.length > 1)
    ? (_openBlock(), _createBlock(DashboardCard, {
        key: 0,
        title: _ctx.title,
        icon: _ctx.icon,
        "show-footer": false,
        "show-error": _ctx.showError,
        "on-reload-click": _ctx.onReloadClick
      }, {
        contentNoPadding: _withCtx(() => [
          _createVNode(_unref(DataTable), {
            class: "fm-table",
            value: !_ctx.loading ? rankedLeaderboard.value : _unref(loadingRows),
            scrollable: "",
            "scroll-height": tableScrollHeight.value,
            style: _normalizeStyle({ minHeight: tableScrollHeight.value }),
            pt: dataTablePt
          }, {
            default: _withCtx(() => [
              _createVNode(LeaderboardTableColumn, {
                key: "rank",
                field: "rank",
                header: "Rank",
                loading: _ctx.loading,
                "loading-width": "28px",
                centred: ""
              }, null, 8, ["loading"]),
              _createVNode(LeaderboardTableColumn, {
                key: "displayName",
                field: "displayName",
                header: _ctx.dataLabel,
                "extra-class": "display-name",
                loading: _ctx.loading
              }, null, 8, ["header", "loading"]),
              (showResponsesColumn.value)
                ? (_openBlock(), _createBlock(LeaderboardTableColumn, {
                    key: "responded",
                    field: "responded",
                    header: "Responses",
                    "extra-class": "responses",
                    "loading-width": "40px",
                    centred: "",
                    loading: _ctx.loading
                  }, null, 8, ["loading"]))
                : _createCommentVNode("", true),
              _createVNode(LeaderboardTableColumn, {
                key: "metric",
                field: "nps",
                header: _ctx.metric,
                "extra-class": "score",
                "loading-width": "80px",
                centred: "",
                loading: _ctx.loading
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", {
                    "aria-labelledby": `fm-table-score-desc-${slotProps.data.rank}`,
                    class: "fm-table__column--score"
                  }, [
                    _createElementVNode("span", {
                      id: `fm-table-score-desc-${slotProps.data.rank}`,
                      class: "screen-reader-only"
                    }, _toDisplayString(_unref(getAriaScoreDesc)(
                                        Number(slotProps.data.nps),
                                        slotProps.data.change,
                                        _ctx.timePeriod,
                                        _ctx.metric
                                    )), 9, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(formatScoreWithPercentage)(
                                        Number(slotProps.data.nps),
                                        _ctx.isFiveScore,
                                        _ctx.csatAsPercent,
                                        _ctx.metric,
                                        _ctx.decimals
                                    )), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass([
                                    'fm-table__column--score__change',
                                    `fm-table__column--score__change--${_unref(getDiffVariant)(Number(slotProps.data.change))}`,
                                ]),
                      "aria-hidden": "true"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), {
                        class: "fm-table__column--score__change__icon",
                        icon: 
                                        _unref(getDiffIcon)(
                                            Number(slotProps.data.change)
                                        )
                                    
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatScoreWithPercentage)(
                                            Number(slotProps.data.change),
                                            _ctx.isFiveScore,
                                            _ctx.csatAsPercent,
                                            _ctx.metric,
                                            _ctx.decimals
                                        )), 1)
                    ], 2)
                  ], 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["header", "loading"])
            ], undefined, true),
            _: 1
          }, 8, ["value", "scroll-height", "style"])
        ]),
        _: 1
      }, 8, ["title", "icon", "show-error", "on-reload-click"]))
    : _createCommentVNode("", true)
}
}

})